(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const stepButton = event.target.closest('[data-quantity] button[data-step]');
    if (stepButton) {
      const input = stepButton.closest('[data-quantity]').querySelector('input');
      if (!input.value || Number.isNaN(Number(input.value))) input.value = input.min || '1';
      const direction = Number(stepButton.dataset.step);
      try { direction > 0 ? input.stepUp() : input.stepDown(); } catch { return; }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.querySelectorAll('.header-disclosure[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
      if (details.contains(event.target) && event.target.closest('a')) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header-disclosure[open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-message]')) return;
    const scope = event.target.closest('.message-field');
    scope.querySelector('[data-message-count]').textContent = event.target.value.length;
    scope.querySelector('[data-message-preview]').textContent = event.target.value;
    scope.querySelector('.message-preview').hidden = !event.target.value.trim();
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-variant-select]')) return;
    const select = event.target;
    const option = select.selectedOptions[0];
    if (!option) return;
    const scope = select.closest('[data-product-section]');
    const add = scope.querySelector('[data-add-button]');
    const available = option.dataset.available === 'true';
    add.disabled = !available;
    scope.querySelector('[data-add-label]').textContent = available ? add.dataset.availableText : add.dataset.unavailableText;
    scope.querySelector('[data-price]').textContent = option.dataset.price;
    const compare = scope.querySelector('[data-compare]');
    compare.hidden = !option.dataset.compare;
    compare.textContent = option.dataset.compare;
    const unit = scope.querySelector('[data-unit]');
    unit.hidden = !option.dataset.unit;
    unit.textContent = option.dataset.unit;
    const quantity = scope.querySelector('input[name="quantity"]');
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.history.replaceState({}, '', url);
    const media = document.getElementById(option.dataset.media);
    if (media) {
      const gallery = scope.querySelector('.product-gallery');
      gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
})();

// Native details controls keep navigation usable without JavaScript.
document.addEventListener('click', (event) => {
  document.querySelectorAll('.routine-nav-dropdown[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.routine-nav-dropdown[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
document.addEventListener('toggle', (event) => {
  if (!event.target.matches('.header-disclosure[open]')) return;
  document.querySelectorAll('.header-disclosure[open]').forEach((other) => {
    if (other !== event.target) other.open = false;
  });
}, true);
